import React, { Component } from 'react';
import { MemberRow as Row, MemberRowItem } from './style';
import { TruncatedText } from '../../../UI/Text';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { MemberPopup } from '../../Popups/MembersPopups';
import { MembersActionCreators } from '../../../../Store/ActionCreators/MembersActionCreators';

class WaitingMemberRow extends Component {
    getState = () => ({
        // id: this.props.id,
    });

    state = {
        ...this.getState(),
    };

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.setState(this.getState());
        }
    }

    toggleStatusClick = e => {
        const { id, handleStatusClick, rowStatusOpen } = this.props;

        if (rowStatusOpen === id) handleStatusClick(null);
        else handleStatusClick(id);
    };

    deleteMember = id => {
        const { onDelete } = this.props;
        onDelete(id);
    };

    resendEmail = () => {
        const { email, fullName, resendEmail } = this.props;
        resendEmail({ email, fullname: fullName });
    };

    requestWithDelay = debounce(() => {
        const {
            state: { credits, paidUntil },
            props: { id, updateMembershipPlanForMember },
        } = this;

        updateMembershipPlanForMember(id, this.state.plansSelected.planMemberId, {
            credits,
            expires_at: paidUntil,
        });
    }, 250);

    render() {
        const { fullName, email, id, closeAll, rowStatusOpen, status } = this.props;
        const isStatusOpen = rowStatusOpen === id;
        const memberStatus = mapStatusToString(status);
        const statusColor = mapStatusToColor(status);

        return (
            <Row>
                <MemberRowItem width={'15%'}>
                    <div style={{ minWidth: '42px', height: '42px' }} />

                    <TruncatedText weight={'bold'} marginLeft={'20px'}>
                        {fullName}
                    </TruncatedText>
                </MemberRowItem>

                <MemberRowItem width={'10%'}>
                    <TruncatedText
                        cursor={'pointer'}
                        color={statusColor}
                        onClick={this.toggleStatusClick}
                        weight={100}
                        opacity={0.8}
                    >
                        {memberStatus}
                    </TruncatedText>

                    {isStatusOpen && <MemberPopup action={this.resendEmail} onClose={closeAll} status={status} />}
                </MemberRowItem>

                <MemberRowItem width={'70%'}>
                    <TruncatedText opacity={0.8} weight={100}>
                        {email}
                    </TruncatedText>
                </MemberRowItem>

                <MemberRowItem justify={'flex-end'} width={'5%'} />
            </Row>
        );
    }
}

const mapStatusToString = status => {
    switch (status) {
        case 0:
            return 'Waiting...';
        case 1:
            return 'Active';
        case 2:
            return 'Pending...';
        case 3:
            return 'Disabled';
        case 4:
            return 'Overdue';
        default:
            return 'Waiting...';
    }
};

const mapStatusToColor = status => {
    switch (status) {
        case 0:
            return 'yellow';
        case 1:
            return 'white';
        case 2:
            return 'yellow';
        case 3:
            return 'darkGrey';
        case 4:
            return 'red';
        default:
            return 'white';
    }
};

const mapDispatchToProps = dispatch => ({
    updateCredits(id, data) {
        dispatch(MembersActionCreators.updateMemberRequest(id, data));
    },
    updateMembershipPlanForMember(memberId, memberPlanId, planData) {
        dispatch(MembersActionCreators.updateMembersMembershipPlanRequest(memberId, memberPlanId, planData));
    },
});

export default connect(
    null,
    mapDispatchToProps,
)(WaitingMemberRow);



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/MemberRow/WaitingMemberRow.js